export default {
  changeLanguageType(languageType, componentName, param) {
    let languagedata = {
      YYLayout: {
        customerService: ['customer service', '客服'],
        overview: ['Overview', '概览页'],
        onlinecommunication: ['Messages', '在线沟通'],
        personalcenter: ['Personal Center', '个人中心'],
        myinformation: ['My Information', '我的信息'],
        myresume: ['My Resume', '个人简历'],
        languagetest: ['Language Test', '语言测试'],
        mysettlement: ['My Settlement', '结算认证'],
        projectcenter: ['Project Center', '任务中心'],
        settlementcenter: ['Settlement Center', '结算中心'],
        feessettlement: ['Fees Settlement', '费用结算'],
        settlementdetail: ['Expense Details', '费用明细'],
        settlementApplicationRecord: ['Application Record', '申请记录'],
        jobhall: ['Job Hall', '任务大厅'],
        joblist: ['Job List', '任务列表'],
        order: ['order management', '订单管理'],
        applicationrecord: ['Application Record', '我的投递'],
        EvaluateRecord: ['Comment record', '评论记录'],
        initiateAnOrderIndex: ['Order list', '订单列表'],
        AppealManagementYYIndex: ['Complaint list', '申诉列表'],
        messagefeedback: ['Notifications', '我的消息'],
        settings: ['Settings', '安全设置'],
        logout: ['Logout', '退出登录'],
        changetype: ['Demand issuance', '发需求'],
        yes: ['Yes', '确定'],
        no: ['No', '取消'],
        login: ['login successfully', '登录成功!'],
        message: {
          tongyong: {
            yes: ['Yes', '确定'],
            no: ['No', '取消'],
            msgcancel: ['Successfully  canceled!', '取消成功!'],
            msgerror: ['Operation failed!', '操作失败!'],
            msgsuccess: ['Operation succeeded', '操作成功!']
          }
        }
      },
      YYOverview: {
        overviewname: ['Overview', '概览页'],
        welcome: ['Welcome to', '欢迎来到'],
        global: ['Global Services', '全球服务'],
        abundant: ['Abundant Resources', '资源丰富'],
        enjoy: ['Enjoy your time here', '好好享受这里的时光'],
        projectaccomplished: ['Projects accomplished', '任务数量'],
        accountdetails: ['Account details', '账户明细'],
        unsettled: ['Unsettled', '未结算'],
        readytobesettle: ['Ready to be settled', '待结算'],
        beingsettle: ['Being settled', '结算中'],
        settled: ['Settled', '已结算'],
        total: ['Total amount', '总金额'],
        cansettled: ['Settleable amount', '可结算金额'],
        frozenAmount: ['Frozen amount', '已冻结金额'],
        personalinformation: ['Personal Information', '个人信息'],
        testcertification: ['Test Certification', '测试认证'],
        settlementinformation: ['Settlement Information', '结算信息'],
        operatinginstructions: {
          name: ['Operating instructions', '操作流程'],
          myinformation: ['My Information', '我的信息'],
          myresume: ['My Resume', '个人简历'],
          languagetest: ['Language Test', '语言测试'],
          mysettlement: ['My Settlement', '结算认证'],
          projectcenter: ['Job Hall', '任务大厅'],
          startwork: ['let’s translate now!', '开始接单之旅']
        },
        message: {
          tongyong: {
            yes: ['Yes', '确定'],
            no: ['No', '取消'],
            msgcancel: ['Successfully  canceled!', '取消成功!'],
            msgerror: ['Operation failed!', '操作失败!'],
            msgsuccess: ['Operation succeeded', '操作成功!']
          }
        }
      },
      YYOnline: {
        name: ['Messages', '在线沟通'],
        resume: ['Resume', '简历'],
        tablabel: {
          whole: ['All', '全部'],
          read: ['Read', '已读'],
          unread: ['Unread', '未读']
        },
        textcontenttype: {
          file: ['[ file ]', '[ 文件 ]'],
          img: ['[ image ]', '[ 图片 ]'],
          type3: ['[ Withdrew a message ]', '[ 撤回了一条消息 ]'],
          type4: ['[ Order Information Card ]', '[ 订单信息卡片 ]'],
          type5: ['[ Commissioned Service Card ]', '[ 委托服务卡片 ]'],
          type6: ['[ Task Information Card ]', '[ 任务信息卡片 ]'],
          type7: ['[ Customer Service Reminder ]', '[ 客服温馨提示 ]'],
          type0: ['[ No news ]', '[ 暂无消息 ]']
        },
        projectCard: {
          card: ['projectCard', '[ 任务卡片 ]']
        },
        placeholder: {
          searchinput: ['Please enter user name to query', '请输入用户名'],
          sendinput: ['Write a message…', '输入消息…']
        },
        message: {
          tongyong: {
            yes: ['Yes', '确定'],
            no: ['No', '取消'],
            msgcancel: ['Successfully  canceled!', '取消成功!'],
            msgerror: ['Operation failed!', '操作失败!'],
            msgsuccess: ['Operation succeeded', '操作成功!'],
            msgonlyonefile: [
              'Only one file can be selected!!',
              '只允许选中一个文件!'
            ],
            msgonlytype: [
              'Only picture types and file types are supported',
              '仅支持图片类型和文件类型'
            ],
            confirmupload: ['Confirm upload?', '确认上传？']
          }
        }
      },
      YYProjectCenter: {
        name: ['Project Center', '任务中心'],
        totalamount: ['Total amount', '总金额'],
        checkList: [
          [
            'Name',
            'No.',
            'Completion time',
            'Languages',
            'Task type',
            'Unit price',
            'Workload'
          ],
          [
            '任务名称',
            '任务编号',
            '结束时间',
            '语种',
            '任务类型',
            '单价',
            '任务量'
          ]
        ],
        tablecol: {
          totalprice: ['Total price', '人民币总价'],
          MYtotalprice: ['Total price', '美元总价'],
          rwlx: ['rwlx', '任务类型'],
          operation: ['Operation', '操作'],
          projectdetails: ['Details', '任务详情'],
          projectnumber: ['No.', '任务编号'],
          translatorname: ['Translator', '译员姓名'],
          projectname: ['Name', '任务名称'],
          completiontime: ['Completion time', '交稿时间'],
          languages: ['Languages', '语种'],
          unitprice: ['Unit price', '单价'],
          tasktype: ['Task type', '任务类型'],
          workload: ['Workload', '任务量']
        },
        placeholder: {
          date: {
            start: ['Start date', '开始日期'],
            end: ['End date', '结束日期']
          },
          projectnum: [
            'Please enter the project No. to query',
            '请输入任务编号'
          ],
          selectlang: ['Please enter the language query', '请输入语种']
        }
      },
      YYProjectDetail: {
        project: {
          name: ['Project information', '任务信息'],
          number: ['No.', '任务编号'],
          translator: ['Translator', '译员姓名'],
          projectname: ['Name', '任务名称'],
          manager: ['Project manager', '项目经理'],
          tasktype: ['Task type', '任务类型'],
          completiontime: ['Completion time', '完成时间'],
          languages: ['Languages', '语种'],
          unitprice: ['Unit Price', '单价'],
          totalpricecny: ['Total price in CNY', '人民币总价'],
          totalpriceusd: ['Total price in USD', '美元总价'],
          workload: ['Workload', '工作量'],
          deductions: ['Deductions', '扣除费用'],
          Deductionsdetails: ['Deductions details', '扣除费用明细'],
          taskspecification: ['Task specification', '任务说明']
        },
        settlement: {
          name: ['Settlement information', '结算信息'],
          time: ['Settlement time', '结算时间'],
          status: ['Settlement status', '结算状态'],
          methods: ['Settlement method', '结算方式']
        }
      },
      YYMessagefeedback: {
        name: ['Notifications', '我的消息'],
        tablabel: {
          notification: ['Recent News', '消息通知'],
          feedback: ['Feedback', '反馈意见']
        },
        notification: {
          allread: ['All read', '全部已读'],
          read: ['Read', '已读'],
          unread: ['Unread', '未读']
        },
        feedback: {
          feedback: ['Feedback', '反馈意见'],
          read: ['Read', '已读']
        },
        type: {
          label: ['Feedback Type', '反馈类型']
        },
        time: {
          label: ['Feedback Time', '反馈时间']
          // place:['Feedback Type','反馈类型'],
        },
        instructions: {
          label: ['Feedback Instructions', '反馈说明'],
          place: ['Please enter Feedback Instructions', '请输入反馈说明']
        },
        status: {
          label: ['Feedback Status', '反馈状态']
          // place:['Feedback Type','反馈类型'],
        },
        operation: {
          label: ['Operation', '操作']
          // place:['Feedback Type','反馈类型'],
        },
        detail: ['Details', '任务详情'],
        select: ['Select', '选择'],
        returns: ['Cancel', '取消'],
        submit: ['Submit', '提交'],
        attachments: ['Relevant attachments', '相关附件'],
        self: ['Self-evaluation', '自我评价']
      },
      YYMessageDetail: {
        name: ['Feedback details', '反馈详情'],
        type: ['Feedback Type', '反馈类型'],
        time: ['Feedback Time', '反馈时间'],
        instructions: ['Feedback Instructions', '反馈说明'],
        status: ['Feedback Status', '反馈状态'],
        attachments: ['Relevant attachments', '相关附件'],
        results: ['Results', '反馈结果']
      },
      YYSettings: {
        name: ['Settings', '安全设置'],
        passwordset: ['Password settings', '密码设置'],
        bingdingset: ['Binding settings', '绑定设置'],
        notificationsset: ['Notifications settings', '通知设置'],
        notifications: {
          notificationsEmail: [
            'Do you accept email notifications',
            '是否接受邮箱通知'
          ],
          notificationsPhone: [
            'Do you accept mobile notifications',
            '是否接受手机通知'
          ]
        },
        password: {
          original: {
            label: ['Enter original password', '旧密码'],
            placeholder: ['Please enter original password', '请输入旧密码']
          },
          news: {
            label: ['Enter new password', '新密码'],
            placeholder: ['Please enter new password', '请输入请密码']
          },
          confirm: {
            label: ['Confirm new password', '确认新密码'],
            placeholder: ['Please enter new password again', '请再次确认新密码']
          },
          verificationcode: {
            label: ['SMS verification code', '短信验证码'],
            placeholder: [
              'Please enter the SMS verification code',
              '请输入验证码'
            ]
          },
          radio: {
            label: {
              email: ['Email', '邮箱'],
              phone: ['Phone', '手机号']
            }
          },
          phonenum: ['phone number', '手机号'],
          emailnum: ['email', '邮箱号'],
          gets: ['Get verification code', '获取验证码'],
          verification: ['Verification code verification', '验证码验证'],
          pass: ['Password  verification', '密码验证']
        },
        binding: {
          email: {
            name: ['Mailbox binding', '绑定邮箱'],
            form: {
              emailaddress: {
                label: ['Email', '邮箱地址'],
                placeholder: ['Please enter email address', '请输入新的邮箱号']
              },
              emailcode: {
                label: ['Email verification code', '邮箱验证码'],
                placeholder: [
                  'Please enter email verification code',
                  '请输入邮箱验证码'
                ]
              }
            },
            message: {
              // confirm1:['']
            }
          },
          phone: {
            name: ['Phone binding', '绑定手机号'],
            form: {
              phoneaddress: {
                label: ['Phone number', '手机号'],
                placeholder: [
                  'Please enter the phone number',
                  '请输入新的手机号'
                ]
              },
              phonecode: {
                label: ['SMS verification code', '手机验证码'],
                placeholder: [
                  'Please enter the phone verification code',
                  '请输入手机验证码'
                ]
              }
            }
          }
        },
        message: {
          confirmsubmit: ['Are you sure to submit?', '确认提交？'],
          msgerror: ['Operation failed!', '操作失败!'],
          msgsuccess: ['Operation succeeded', '操作成功!'],
          msgdataerror: ['System abnormality', '系统异常!']
        },
        returns: ['Cancel', '取消'],
        gets: ['Get verification code', '获取验证码'],
        submit: ['Submit', '提交'],
        yes: ['Yes', '确定'],
        no: ['No', '取消'],
        rebind: ['Rebind', '重新绑定']
      },
      YYLogin: {
        bannerwelcome: ['Welcome to', '欢迎来到'],
        bannerglobal: ['Global Services ', '全球服务'],
        bannerabundant: ['Abundant Resources', '资源丰富'],
        bannermassive: ['Massive Translators', '众多译员'],
        bannertext: [
          'Here’s a sea of native and professional translators. Join us now.',
          '这里有全国各地的专业翻译人员。现在就加入我们，开始新的翻译生涯。'
        ],
        bannertext2: [
          'On Yedeer, native language translation and proofreading of worldwide languages can be perfectly accomplished with a sea of translators, spanning more than 80 languages of Chinese to foreign, English to foreign, and foreign to foreign translation.',
          '我们拥有大量的翻译人员，可以实现全球语言的母语翻译和校对，涵盖中译外、英译外、外译外80多种语言。'
        ],
        bannertext3: [
          'We can realize native language translation and proofreading of worldwide languages with a big number of translators, spanning more than 80 languages of Chinese to foreign, English to foreign, and foreign to foreign translation.',
          '我们拥有大量的翻译人员，可以实现全球语言的母语翻译和校对，涵盖中译外、英译外、外译外80多种语言。'
        ],
        forgetPassword: [
          `Don't be afraid to forget your password.`,
          '你不要担心会忘记密码'
        ],
        confirm: ['Join as a client or freelancer', '确认'],
        findpeople: ['I’m a client, hiring for a project', '发需求'],
        forwork: ['I’m a freelancer, looking for work', '找工作'],
        logins: ['login successfully', '登录成功!'],
        login: {
          name: ['Login', '登录'],
          text: {
            forget: ['Forgot password？', '忘记密码？'],
            passlogin: ['Get verification code', '获取验证码'],
            newuser: ['New user?', '新用户？'],
            already: ['Already have an account？', '已注册?'],
            tip1: [
              'Please enter your account information',
              '请输入您的账号信息'
            ]
          }
        },
        signup: {
          name: ['Sign up', '注册'],
          tip1: ['Register an account below', '请在注册页面注册您的账号']
        },
        reset: {
          name: ['Reset password', '重置密码']
        },
        welcome: ['Welcome to', '欢迎来到'],
        account: ['Account No.', '账号'],
        password: ['Password', '密码'],
        createpassword: ['Create password', '密码'],
        newpassword: ['Enter new password', '新密码'],
        confirmpassword: ['Confirm password', '确认密码'],
        code: ['Verification code', '验证码'],
        yqm: ['Invitation code', '邀请码'],
        nexts: ['Next', '下一步'],
        confirmreset: ['Confirm reset', '确认重置'],

        getcode: ['Get verification code', '获取验证码'],
        passlogin: ['Password login', '密码登录'],
        codelogin: ['Verification code login', '验证码登录'],
        placeholder: {
          account: ['Please enter phone number/email', '请输入手机号或邮箱'],
          password: ['Please enter password', '请输入密码'],
          confirmpassword: ['Please enter password again', '请再次输入密码'],
          createpassword: ['Please enter password', '请输入密码'],
          newpassword: ['Please enter new password', '请输入新密码'],

          yqm: ['Please enter invitation code', '请输入邀请码'],
          code: ['Please enter verification code', '请输入验证码'],
          verify: ['Please slide to verify', '请滑动滑块验证'],
          verifycuccess: ['Verified', '验证成功']
        }
      },
      // 步骤条
      YYStep: {
        myinformation: ['My Information', '我的信息'],
        myresume: ['My Resume', '个人简历'],
        languagetest: ['Language Test', '语言测试'],
        mysettlement: ['My Settlement', '结算认证']
      },
      // 基础信息页
      YYMyInformation: {
        basic: {
          name: ['Basic Information', '基本信息'],
          introduce: [
            'Name Please fill in your real name.',
            '名称请填写真实的姓名。'
          ],
          realname: {
            label: ['Name', '真实姓名'],
            placeholder: ['Please enter name', '请输入真实姓名']
          },
          location: {
            label: ['Location', '所在地'],
            placeholder: ['Please enter the location ', '请输入所在地']
          },
          gender: {
            label: ['Gender', '性别'],
            placeholder: ['Please select gender', '请选择性别']
          },
          datebirth: {
            label: ['Date of birth', '出生日期'],
            placeholder: ['Please select birthday', '请选择出生日期']
          },
          country: {
            label: ['Country & Region', '国家/地区'],
            placeholder: ['Please select country & region', '请选择国家/地区']
          },
          location: {
            label: ['Location', '所在地'],
            placeholder: ['Please enter the location', '请输入所在地']
          },
          nativelanguage: {
            label: ['Native language', '母语'],
            placeholder: ['Please select native language', '请选择母语']
          },
          languageskills: {
            label: ['Language skill', '擅长语种'],
            placeholder: ['Please select language skill', '请选择擅长语种']
          },
          translationfield: {
            label: ['Translation field', '专业领域'],
            placeholder: ['Please select translation field', '请选择翻译领域']
          },
          translationexperience: {
            label: ['Translation experience', '翻译年限'],
            placeholder: [
              'Please select translation experience',
              '请选择翻译年限'
            ]
          },
          currency: {
            label: ['Currency', '币种'],
            placeholder: ['Please select a currency', '请选择币种']
          },
          sourcedata: {
            label: ['Where do you know Yedeer?', '您从哪里知道Yedeer？'],
            placeholder: [
              'Please select the source information',
              '请选择来源信息'
            ]
          },
          canwriteglobal: {
            label: ['Global media platform', '全球媒体平台'],
            placeholder: [
              'Please enter the global media platform',
              '请输入全球媒体平台'
            ]
          },
          canwriteother: {
            label: ['Other', '其他'],
            placeholder: ['Please enter another', '请输入其他']
          }
        },
        contact: {
          name: ['Contact Information', '联系信息'],
          phone: {
            label: ['Phone number', '电话号码'],
            placeholder: ['Please enter phone number', '请输入电话号码']
          },
          wechat: {
            label: ['WeChat ID', '微信号码'],
            placeholder: ['Please enter WeChat ID', '请输入微信号码']
          },
          email: {
            label: ['Email', '邮箱号码'],
            placeholder: ['Please enter Email', '请输入邮箱号码']
          },
          qq: {
            label: ['QQ', 'QQ'],
            placeholder: ['Please enter QQ number', '请输入QQ号码']
          },
          skype: {
            label: ['Skype ID', 'Skype号码'],
            placeholder: ['Please enter Skype ID', '请输入Skype号码']
          },
          other: {
            label: ['Others', '其它'],
            placeholder: [
              'Please enter other contact information',
              '请输入其他联系方式'
            ]
          },
          message: {}
        },
        langtranslation: {
          name: ['Languages and  Translation Output', '语言及翻译产量'],
          day: ['Words/Day', '字数/天'],
          week: ['Words/Week', '字数/周'],
          sourcelang: {
            placeholder: ['Select a source language', '选择源语种']
          },
          translastion: {
            placeholder: ['select a translation', '选择类型']
          },
          targetlang: {
            placeholder: ['Select a target language', '选择源语种']
          },
          number: {
            placeholder: ['Enter output numbers here', '在这里输入数字']
          }
        },
        nexts: ['Next', '下一页'],
        previous: ['Previous', '上一页'],
        returns: ['Cancel', '取消'],
        submit: ['Submit', '提交']
      },
      // 我的简历页面
      YYMyResume: {
        previous: ['Previous', '上一页'],
        nexts: ['Next', '下一页'],
        returns: ['Cancel', '取消'],
        submit: ['Submit', '提交'],
        select: ['Select', '选择'],
        ok: ['Ok', '确定'],
        cancel: ['Cancel', '取消'],
        datadelete: [
          'The data will be permanently deleted. Are you sure you want to continue?',
          '数据将被永久删除。是否确实要继续？'
        ],
        education: {
          name: ['Education Background', '教育经历'],
          university: {
            label: ['University name', '学校名称'],
            placeholder: ['Please enter university name', '请输入学校名称']
          },
          major: {
            label: ['Major', '专业名称'],
            placeholder: ['Please enter major', '请输入专业名称']
          },
          duration: {
            label: ['Duration', '就读时间'],
            placestart: ['Start date', '开始日期'],
            placeend: ['End date', '结束日期']
          },

          degree: {
            label: ['Degree', '学历'],
            placeholder: ['Please select degree', '请选择学历']
          },
          graduateFile: {
            label: ['graduateFileName', '毕业证书'],
            degree: ['degreeFileName', '学位证书']
          }
        },
        language: {
          name: ['Language Certificate', '语言证书'],
          language: {
            label: ['Languages', '语种'],
            placeholder: ['Please select languages', '请选择语言']
          },
          certificate: {
            label: ['Language Certificate', '证书'],
            placeholder: ['Please select language certificate', '请选择证书']
          },
          level: {
            label: ['Certificate level', '等级'],
            placeholder: ['Please select certificate level', '请选择等级']
          },
          file: {
            label: ['Certificate photo', '附件']
          }
        },
        employment: {
          name: ['Employment History', '工作经历'],
          company: {
            label: ['Company name', '公司名称'],
            placeholder: ['Please enter company name', '请输入公司名称']
          },
          occupation: {
            label: ['Occupation', '职位名称'],
            placeholder: ['Please enter occupation', '请输入职位名称']
          },
          period: {
            label: ['Period', '在职时间'],
            placestart: ['Start date', '开始日期'],
            placeend: ['End date', '结束日期']
          },
          description: {
            label: ['Job description', '工作描述'],
            placeholder: ['Please enter job description', '请输入工作描述']
          }
        },
        project: {
          name: ['Project Experience', '项目经历'],
          projectname: {
            label: ['Name', '项目名称'],
            placeholder: ['Please enter project name', '请输入项目名称']
          },
          duration: {
            label: ['Duration', '项目时间'],
            placestart: ['Start date', '开始日期'],
            placeend: ['End date', '结束日期']
          },
          description: {
            label: ['Project description', '项目描述'],
            placeholder: ['Please enter project description', '请输入项目描述']
          }
        },
        evaluation: {
          name: ['Self-evaluation', '自我评价']
        }
      },
      // 任务
      YYJobHall: {
        checkresume: [
          'Please complete your resume information!',
          '请填写您的简历信息!'
        ],
        placeholder: {
          selectLX: ['Please select project type', '请选择任务类型'],
          selecttype: ['Please select project status', '请选择任务状态'],
          selectlang: ['Please select language', '请选择语种'],
          area: ['Please select fields', '请选择领域'],
          projectnum: [
            'Please enter the project No. to query',
            '请输入任务编号'
          ],
          submissiontime: ['Submission Time:', '提交时间:'],
          numwords: ['Workload', '工作量'],
          words: ['words', '字'],
          jobdetails: ['Job Details', '任务详情'],
          applyStateNot: ['apply', '我要申请'],
          applyState: ['applied', '已申请'],
          apply: ['Apply', '申请']
        },
        // 申请记录
        applyrecord: {
          name: ['Application Record', '申请记录']
        },
        applydetail: {
          name: ['Details of Application Records', '申请记录详情'],
          contentname: ['Application Content', '申请内容'],
          instructions: ['Application Instructions', '申请说明'],
          expectedprice: ['Expected Price', '预计价格'],
          resume: ['Resume or project case', '简历或项目案例']
        },
        // 任务列表
        list: {
          name: ['Job List', '任务列表'],
          // 笔译
          translation: {
            name: ['Translation', '笔译']
          },
          // 口译
          interpretation: {
            name: ['Interpretation', '口译']
          }
        },

        jobdetails: {
          name: ['Job Details', '任务详情'],
          online: ['Messages', '在线沟通'],
          jobno: ['No.', '任务编号'],
          description: ['Project Description', '任务描述'],
          projectname: ['Name', '任务名称'],
          language: ['Languages', '语种'],
          status: ['Status', '任务状态'],
          requirements: ['Project Requirements', '任务要求'],
          estimatedoutput: ['Estimated Effort', '预估工作量'],
          //   estmateddate:['Estimated Date of Submission','预估提交时间'],
          estmateddate: ['Deadline ', '截止日期'],
          releaseTime: ['Release Time', '发布时间'],
          projectcontent: ['Remarks', '备注'],
          salary: ['Salary', '薪酬'],
          note: ['Delivery Instructions', '详情说明'],
          whField: ['Fields', '专业领域'],
          qrcode: ['QR code', '二维码'],
          projectType: ['Type', '任务类型'],
          resumeinfo: ['Contact Information', '联系人信息'],
          address: ['Address', '地址'],
          email: ['Email', '邮箱'],
          phone: ['Phone', '电话'],
          briefIntroduction: ['Brief Introduction', '简介']
        },
        copeTxt: [
          'Successfully copied sharing link to clipboard!',
          '已成功复制分享链接到剪贴板!'
        ]
      },
      // 订单列表 译员
      initiateAnOrderIndex: {
        name: ['Order management', '订单管理'],
        place: {
          supUserName: [
            'Please enter the project No. to query',
            '请输入需求人名称'
          ],
          projectOrderId: [
            'Please enter the project type. to query',
            '请输入订单编号'
          ],
          orderName: [
            'Please enter the project time. to query',
            '请输入订单名称'
          ],
          startTime: [
            'Please enter the project name. to query',
            '请输入开始时间'
          ],
          endTime: [
            'Please enter the project name. to query',
            '请输入结束时间'
          ],
          orderStatus: [
            'Please enter the project name. to query',
            '请输入订单状态'
          ]
        },
        OrderPaymentAmount: ['Order payment amount', '支付金额'],
        createByName: ['createByName', '需求人名称'],
        createBy: ['createBy', '需求人编号'],
        projectOrderId: ['projectOrderId', '订单编号'],
        orderName: ['orderName', '订单名称'],
        projectReleaseInforId: ['projectReleaseInforId', '任务编号'],
        orderStatus: ['orderStatus', '订单状态'],
        startTime: ['startTime', '开始时间'],
        deliverTime: ['deliver time', '交付时间'],
        actualEndTime: ['actualEndTime', '验收时间'],
        createTime: ['createTime', '创建时间'],
        endTime: ['endTime', '结束时间'],
        workload: ['workload', '工作量'],
        unitPrice: ['unitPrice', '单价'],
        unitName: ['unitName', '单位'],
        amountOfMoney: ['amountOfMoney', '订单金额'],
        commissionXQ: ['commissionXQ', '订单手续费'],
        orderType: ['orderType', '订单类型'],
        whFieldId: ['whFieldId', '专业领域'],
        sourceLanguage: ['whFieldId', '源语种'],
        targetLanguage: ['targetLanguage', '目标语种'],

        operationField: {
          send: ['send', '已发送'],
          receive: ['receive', '已接收'],
          rejection: ['rejection', '已拒收'],
          start: ['start', '启动中'],
          end: ['end', '已结束'],
          appeal: ['appeal', '申诉中']
        },
        revise: ['revise', '修改'],
        operation: ['Operation', '操作'],

        operationAdd: {
          receive: ['receive', '接收'],
          turnDown: ['turnDown', '拒绝'],
          result: ['result', '交付成果'],
          appeal: ['appeal', '申诉'],
          evaluate: ['evaluate', '评价']
        },

        checkList: [
          [
            'Project No.',
            'Client No.',
            'Workload',
            'Unit price',
            'Unit',
            'Order amount',
            'Order handling fee'
          ],
          [
            '任务编号',
            '需求人编号',
            '工作量',
            '单价',
            '单位',
            '订单金额',
            '订单手续费'
          ]
        ],

        // 订单信息弹窗
        deliverable: {
          orderInformation: ['order information', '订单信息'],
          orderReference: ['order reference', '订单编号'],
          OrderName: ['Order name', '订单名称'],
          supName: ['name of the supplier', '需求人名称'],
          sourceLanguage: ['Source language', '源语种'],
          targetLanguage: ['Target language', '目标语种'],
          OrderTypes: ['Order types', '订单类型'],
          whField: ['Field', '专业领域'],
          startTime: ['start time', '开始时间'],
          createTime: ['create time', '创建时间'],
          deliverTime: ['deliver time', '交付时间'],
          actualEndTime: ['actual end time', '验收时间'],
          orderDescription: ['orderDescription', '订单详情'],
          endTime: ['end time', '结束时间'],
          upload: ['Results upload', '成果上传'],
          file: ['Delivery document', '交付文件'],
          description: ['Delivery description', '交付说明'],

          Payment: ['Order amount confirmation', '订单金额'],
          workload: ['workload', '工作量'],
          unitPrice: ['Unit/Price', '单价/单位'],
          totalprices: ['total prices', '订单金额'],
          serviceharge: ['service charge', '订单手续费'],
          totalamount: ['Total amount', '支付金额'],

          resultsUpload: ['Results upload', '成果上传'],
          deliverFile: ['Delivery document', '交付文件'],
          deliverDescription: ['Delivery description', '交付说明']
        },

        // 评价
        evaluate: {
          evaluateGrade: ['evaluate grade', '评价星级'],
          evaluateDescription: ['evaluate description', '评价描述']
        },

        // 申诉
        appeal: {
          appealType: ['Type of appeal', '申诉类型'],
          reasonForAppeal: ['Cause of appeal', '申诉事由'],
          appealEvidenceFile: ['Evidence attachment', '证据附件']
        },

        select: ['select', '上传'],
        choice: ['choice', '选择'],
        delivery: ['Confirm delivery', '确认交付'],
        close: ['close', '关闭']
      },
      initiateAnOrderYY: {
        name: ['initiateAnOrder', '订单'],
        userTitle: ['', '需求人信息'],
        country: ['Country & Region', '国家/地区'],
        nativelanguage: ['Native language', '母语'],
        languageskills: ['Language skill', '擅长语种'],
        area: ['Area of expertise', '专业领域'],

        OrderInfomation: ['Order Information', '订单信息'],
        OrderName: ['Order name', '订单名称'],
        OrderTypes: ['Order types', '订单类型'],
        SourceLanguage: ['Source language', '源语种'],
        TargetLanguage: ['Target language', '目标语种'],
        startTime: ['start time', '开始时间'],
        endTime: ['end time', '结束时间'],
        whFieldId: ['professional field', '专业领域'],
        OrderFile: ['Order file', '订单文件'],
        select: ['select', '上传'],
        choice: ['choice', '选择'],
        orderIllustration: ['order illustration', '订单说明'],

        projectInfo: {
          projectReleaseInforId: ['Position Id', '任务编号'],
          projectname: ['Position name:', '任务名称：'],
          CompanyName: ['Company name:', '公司名称：'],
          projecttype: ['Type', '任务类型'],
          projectstatus: ['Status', '任务状态'],
          release: ['Release date', '发布时间'],
          expiration: ['Due date', '到期时间'],
          area: ['Fields: ', '擅长领域：'],
          SourceLanguage: ['Source language', '源语种'],
          TargetLanguage: ['Target language', '目标语种']
        },

        OrderInfoRules: {
          OrderName: ['Order name', '请输入订单名称'],
          OrderNumber: ['Order number', '请输入订单编号'],
          OrderTypes: ['Order types', '请输入订单类型'],
          SourceLanguage: ['Source language', '请输入源语种'],
          TargetLanguage: ['Target language', '请输入目标语种'],
          startTime: ['start time', '请输入开始时间'],
          endTime: ['end time', '请输入结束时间'],
          whFieldId: ['professional field', '请输入专业领域'],
          OrderFile: ['Order file', '订单文件'],
          orderIllustration: ['order illustration', '请输入订单说明'],
          UnitPrice: ['UnitPrice', '请输入单价或单位'],
          unit: ['UnitPrice', '请输入单位'],
          price: ['UnitPrice', '请输入单价'],
          workload: ['workload', '请输入工作量']
        },
        projectPlace: {
          projectnum: [
            'Please enter the project No. to query',
            '请输入任务编号'
          ],
          projectType: [
            'Please enter the project type. to query',
            '请输入任务类型'
          ],
          projectCreationTime: [
            'Please enter the project time. to query',
            '请输入任务发布时间'
          ],
          projectName: [
            'Please enter the project name. to query',
            '请输入任务名称'
          ]
        },

        orderAmount: ['Order amount', '订单金额'],
        workload: ['workload', '工作量'],
        UnitPrice: ['Unit/Price', '单价/单位'],
        unit: ['unit', '单位'],
        price: ['price', '单价'],
        money: ['money', '订单金额'],
        serviceharge: ['service charge', '订单手续费'],
        totalprices: ['total prices', '支付金额'],

        return: ['Cancel', '返回'],
        submit: ['Submit', '提交']
      },
      // 结算中心
      YYSettlement: {
        checkList: [
          ['Completion time', 'Unit Price', 'Workload', 'Project manager', 'Project manager','Feedback on unsealing review'],
          ['交稿时间', '单价', '任务量', '项目经理','解封审核反馈']
        ],
        settlementfailed: ['Settlement failed', '结算失败'],
        settlementsuccessful: ['Settlement successful', '结算成功'],
        settlementdetails: ['Expense Details', '结算详情'],
        settlementmethod: ['Settlement method', '结算方式'],
        dialogtext: [
          'Dear friend，please carefully check the project information, ID card information, bank information and phone number before operation (only support your own bank card). If you have any questions, please contact the project manager as soon as possible. The monthly fee settlement can only be submitted once (unsettled fees can be combined and submitted across months). The system settlement and reconciliation time is from the 1st to the 24th of each month. If you do not submit the settlement in time, the amount will be automatically accumulated to the next month. If the settlement amount is less than CNY 100, the system cannot submit the settlement, and the amount will be automatically accumulated to the next month. Other fees are not shown here, thank you for your support and understanding!',
          '尊敬的用户，您好，请在操作之前认真核对任务信息、身份证信息和银行信息和手机号码（仅支持本人银行卡提现）。如有问题，请尽快与项目经理联系。每月费用结算仅可提交一次（可跨月合并提交），系统结算对账时间为每月1-24日，若您未及时提交结算，金额将自动累计到下个月。结算金额为100元以下的系统无法提交结算，金额将自动累计到下个月。其他费用并未在此显示，感谢您的支持与理解！'
        ],
        methods: {
          bankcard: ['Bank card applied in China', '中国境内银行卡'],
          paypal: ['PayPal', 'PayPal'],
          payoneer: ['Payoneer', 'Payoneer']
        },
        status: {
          settled: ['Settled', '已结算'],
          unsettled: ['Unsettled', '待结算'],
          ready: ['Ready to be settled', '可结算'],
          beingsettle: ['Being settled', '结算中'],
          frozensettle: ['Frozen', '已冻结']
        },
        settlementtime: ['Settlement time', '结算时间'],
        settlementstatus: ['Settlement status', '结算状态'],

        feessettlement: {
          name: ['Fees Settlement', '费用结算'],
          read: ['Read', '已读'],
          tip1: [
            'Please improve authentication and settlement method!',
            '请完善个人实名认证及结算方式!'
          ],
          tip2: [
            'Please select the data to be unblocked!',
            '请选择要解封的数据!'
          ],
          tip3: [
            'Prohibit selecting data from unblocking!',
            '禁止选择解封中的数据!'
          ],
          tip4: [
            'Please select frozen data!',
            '请选择已冻结的数据!'
          ],
          tip5: [
            'The unsealing application has been submitted!',
            '解封申请已提交!'
          ],
          tip6: [
            'Failed to submit unsealing application!',
            '解封申请提交失败!'
          ],
          rwlx: ['rwlx', '任务类型'],
          totalamount: ['Total amount', '总金额'],
          settlement: ['Settlement', '结算'],
          startdate: ['Start date', '开始日期'],
          enddate: ['End date', '结束日期'],
          projectnumber: ['No.', '任务编号'],
          projectname: ['Name', '任务名称'],
          projectmanager: ['Project manager', '项目经理'],
          time: ['Completion time', '交稿时间'],
          languages: ['Languages', '语种'],
          totalprice: ['Total price', '总价'],
          workload: ['Workload', '工作量'],
          tasktype: ['Task type', '任务类型'],
          unit: ['Unit Price', '单价'],
          manager: ['Project manager', '项目经理'],
          operation: ['Operation', '操作'],
          projectdetails: ['Details', '任务详情'],
          reminder: ['Settlement reminder', '结算提示'],
          djsqfailure: ['Feedback on unsealing review', '解封审核反馈']
        },
        tip1: ['Please select a settlement method!', '请选择结算方式!'],
        tip2: ['Please select a settlement method!', '请选择结算方式和劳务结途!'],
        settleform: {
          name: ['Confirm settlement information', '确认结算信息'],
          realname: {
            label: ['Name', '真实姓名']
          },
          idcard: {
            label: ['ID Card', '身份证号']
          },
          cardnumber: {
            label: ['Card number', '银行卡号']
          },
          region: {
            label: ['The region of opening bank', '开户行所在地']
          },
          openbank: {
            label: ['Opening bank', '开户银行']
          },
          openbranch: {
            label: ['Opening branch', '开户支行']
          },
          paypal: {
            label: ['PayPal', 'PayPal']
          },
          payoneer: {
            label: ['Payoneer', 'Payoneer']
          }
        },
        corporateform: {
          name: ['Chinese corporate card', '企业信息认证'],
          realname: {
            label: ['corporate ID', '公司名称']
          },
          dutyParagraph: {
            label: ['Unified Social Credit Code', '统一社会信用代码']
          },
          cardnum: {
            label: ['corporate Card number', '收款账号']
          },
          place: {
            label: ['The region of opening corporate', '开户行所在地'],
            placeprovince: ['Please select the province', '请选择所在省份'],
            placecity: ['Please select the city', '请选择所在城市']
          },
          corporate: {
            label: ['Opening corporate', '收款银行']
          },
          branch: {
            label: ['Opening branch', '开户支行']
          }
        },
        settlement: {
          name: ['Settlement', '结算'],
          returns: ['Cancel', '返回'],
          submit: ['Submit', '提交'],
          certified: ['Certified', '已认证'],
          uncertified: ['Not Certified', '未认证'],
          selectmethods: ['Select settlement method', '选择结算方式'],
          selectmethods2: ['Select the labor payment method', '选择劳务结途'],
          selectmethodsTS: ['Foreign bank cards cannot be settled through the system!', '境外银行卡无法通过系统结算！'],
          bank: {
            name: ['Chinese bank card', '中国银行卡'],
            introduce: [
              'This settlement method is only applicable to Chinese debit cards with UnionPay logo.',
              '此结算方式仅适用于带有中国银联标志的中国借记卡。'
            ]
          },
          corporate: {
            name: ['Chinese corporate card', '企业信息认证'],
            introduce: [
              'This settlement method is only applicable to Chinese debit cards with UnionPay logo.',
              '此结算方式仅适用于带有中国银联标志的中国借记卡。'
            ]
          },
          paypal: {
            name: ['PayPal', 'PayPal'],
            introduce: [
              'USD only(3% handling fee for USD payment).',
              '仅美元付款(美元付款需收取3%手续费)。'
            ]
          },
          payoneer: {
            name: ['Payoneer', 'Payoneer'],
            introduce: [
              'USD only (The minimum amount of settlement is $50).',
              '仅限美元(最低结算金额为50美元)'
            ]
          },
          gdg: ['Corporate to Corporate', '公对公'],
          lxlw: ['Continuous Labor', '连续性劳务'],
          yblw: ['General Labor', '一般劳务'],
          jnyh: ['Domestic Bank Card', '境内银行卡'],
          jwyh: ['Overseas Bank Card', '境外银行卡']
        },
        expensedetail: {
          name: ['Expense details', '费用明细'],
          totalexpenses: ['Total expenses', '合计费用'],
          totalexpenses2: ['Freezing and thawing costs', '冻结合计费用'],
        },
        settlementApplicationRecord: {
          name: ['Application Record', '申请记录'],
          projectName: ['project', '任务'],
          je: ['Total price', '总价'],
          skrName: ['payee', '收款人'],
          khh: ['Opening bank', '开户银行'],
          qsTime: ['Application Time', '申请时间'],
          txState: ['Application status', '申请状态'],
          txTime: ['Settlement time', '结算时间']
        }
      },
      // 语言测试
      YYLanguagetest: {
        previous: ['Previous', '上一页'],
        nexts: ['Next', '下一页'],
        returns: ['Cancel', '返回'],
        submit: ['Submit', '提交'],
        select: ['Select', '选择'],
        yes: ['Yes', '确定'],
        no: ['No', '取消'],
        ok: ['Ok', '确定'],
        back: ['Back', '返回'],
        passed: ['Passed', '通过'],
        failed: ['Failed', '失败'],
        starttest: ['Start test', '开始测试'],
        exittest: ['Exit test', '退出测试'],
        nextquestion: ['Next question', '下一题'],
        previousquestion: ['Previous question', '上一题'],
        passrate: ['Pass rate', '合格率'],
        passingrate: ['Passing rate', '合格率'],
        submittime: ['Submission Time', '提交时间'],
        pass: [
          "Congratulations, you've passed the test!",
          '恭喜你，你通过测试了!'
        ],
        fail: ['Sorry, you failed the test!', '对不起，你没有通过测试!'],
        languagepairs: [
          'Language pairs available for testing',
          '可用于测试的语言对'
        ],
        langtest: {
          name: ['Language test', '语言测试'],
          tip2: [
            'You will fail this test if you switch the page more than three times!',
            '如果您切换页面超过三次，您将无法通过此测试!'
          ],
          tip3: {
            one: ['The number of page switches left is ', '剩下的页面开关数是'],
            two: [
              'after you have already changed the page once. You will fail this test if it happens more than three times, so pay attention!',
              '在您已经更改页面一次之后。如果这种情况发生三次以上，你就会不及格，所以要注意了!'
            ]
          },
          tip4: [
            'The test answer has not been submitted. Are you sure to exit the test?',
            '没有提交测试答案，确认退出测试？'
          ],
          tip5: ['Time is up, please sumbit!', '时间已到,请提交测试!'],
          tip6: [
            "Confirm to submit? You can't edit any of the details after submission!",
            '确认提交测试?提交后将不能继续测试!'
          ],
          tip1: [
            'View language pairs available for testing',
            '查看可用于测试的语言对'
          ],
          title1: [
            'Dear translator/interpreter , there are 30 questions in this test , including vocabulary and grammar . For each question , only one answer is correct . Please complete the test within 20 minutes , and a correct rate of 60% and above is considered a pass .',
            '亲爱的译员，这次考试共有30道题，包括词汇和语法。每个问题只有一个答案是正确的。请在20分钟内完成测试，正确率在60%及以上即为通过。'
          ],
          sourcelang: {
            label: ['Source language', '源语种'],
            placeholder: ['Please select source language', '请选择源语种']
          },
          targetlang: {
            label: ['Target language', '目标语种'],
            placeholder: ['Please select target language', '请选择目标语种']
          },
          testtitle: {
            selection: ['vocabulary selection', '词汇选择'],
            replacement: ['vocabulary replacement', '词汇替换'],
            errors: ['correcting grammatical errors', '语法纠错']
          }
        },
        testrecords: {
          name: ['Test records', '测试记录']
        }
      },
      // 个人结算认证
      YYMySettlement: {
        previous: ['Previous', '上一页'],
        returns: ['Cancel', '返回'],
        submit: ['Submit', '提交'],
        select: ['Select', '选择'],
        certified: ['Certified', '已认证'],
        notcertified: ['Not certified', '未认证'],
        tip1: [
          'Please upload the photos of your ID card/your passport.',
          '请上传你的身份证/护照图片'
        ],

        real: {
          name: ['Authentication', '实名认证'],
          type: {
            label: ['Type', '证件类型'],
            radio1: ['ID card No.', '身份证'],
            radio2: ['Passport No.', '护照']
          },
          idcardname: {
            label: ['Name on ID card', '身份证姓名'],
            placeholder: [
              'Please enter Name on ID card',
              '请输入你的身份证姓名'
            ]
          },
          passportname: {
            label: ['Name on passport', '护照姓名'],
            placeholder: ['Please enter Name on passport', '请输入你的护照姓名']
          },
          idcardno: {
            label: ['ID card No.', '身份证号码'],
            placeholder: ['Please enter ID number', '请输入你的身份证号码']
          },
          passportno: {
            label: ['Passport No.', '护照号码'],
            placeholder: ['Please enter passport No.', '请输入护照号码']
          },
          idcardfile: {
            label: ['ID card photo', '身份证附件']
          },

          passportfile: {
            label: ['Passport photo', '护照附件']
          }
        },
        settlement: {
          name: ['Settlement method', '结算方式']
        },
        identityCard: {
          introduce: [
            'Please ensure accurate real name authentication information, as it cannot be modified once saved.',
            '请确保您的实名认证信息填写准确，一经确实无法修改。'
          ]
        },
        realNameAuthentication: {
          issue: [
            'Before entering your real name, please note that:',
            '在填写实名认证之前，请您仔细阅读以下注意事项。'
          ],
          issue1: [
            '1. Your real name must match the information in "My Information - Basic Information - Real Name";',
            '1. 您的实名认证姓名必须同"我的信息-基本信息-真实姓名"保持一致。'
          ],
          issue2: [
            '2. Only ID card or passport information can be used for authentication;',
            '2. 您的实名认证信息只能填写"身份证信息"或"护照信息"。'
          ],
          issue3: [
            '3. Once authenticated, your information cannot be changed. If there are any errors, please contact Yedeer customer service.',
            '3. 实名认证完成后信息将不能修改，若实名认证信息有误请联系Yedeer客服。'
          ]
        },
        bank: {
          name: ['Chinese bank card', '中国银行卡'],
          introduce: {
            issue: [
              'Before finishing the settlement certification, please note that:',
              '在填写结算认证之前，请您仔细阅读以下注意事项。'
            ],
            issue1: [
              '1. Settlement only applies to China UnionPay debit cards;',
              '1. 该结算方式只适用于带有中国银联标志的借记卡。'
            ],
            issue2: [
              '2. Accurately fill in real document information for proper fee issuance.',
              '2. 为确保费用准确无误发放，请填写真实证件信息。'
            ]
          },
          realname: {
            label: ['Name on ID card/Passport', '身份证/护照姓名'],
            placeholder: ['Please enter Name', '请输入真实姓名']
          },
          idcardno: {
            label: ['ID card/Passport No.', '身份证/护照号码'],
            placeholder: ['Please enter ID card No.', '请输入证件号码']
          },
          cardnum: {
            label: ['Card number', '卡号'],
            placeholder: ['Please enter Card number', '请输入卡号']
          },
          place: {
            label: ['The region of opening bank', '开户行所在地'],
            placeprovince: ['Please select the province', '请选择所在省份'],
            placecity: ['Please select the city', '请选择所在城市']
          },
          openingbank: {
            label: ['Opening bank', '开户行'],
            placeholder: ['Please enter Opening branch', '请输入开户行']
          },
          branch: {
            label: ['Opening branch', '开户支行'],
            placeholder: ['Please enter Opening branch', '请输入开户支行']
          }
        },
        corporate: {
          name: ['Chinese corporate card', '企业信息认证'],
          introduce: {
            issue: [
              'Before finishing the settlement certification, please note that:',
              '在填写结算认证之前，请您仔细阅读以下注意事项。'
            ],
            issue1: [
              '1. Settlement only applies to China UnionPay debit cards;',
              '1. 该结算方式只适用于带有中国银联标志的借记卡。'
            ],
            issue2: [
              '2. Accurately fill in real document information for proper fee issuance.',
              '2. 为确保费用准确无误发放，请填写真实证件信息。'
            ],
            introduction: [
              'If you are a supplier team, please conduct enterprise information authentication (the supplier team needs to provide translation fee invoices)',
              '如果你是供应商团队,请进行企业信息认证(供应商团队需要提供翻译费发票)'
            ]
          },
          realname: {
            label: ['corporate ID', '公司名称'],
            placeholder: ['Please enter corporateName', '请输入公司名称']
          },
          dutyParagraph: {
            label: ['Unified Social Credit Code', '统一社会信用代码'],
            placeholder: [
              'Please enter a unified social credit code',
              '请输入统一社会信用代码'
            ]
          },
          cardnum: {
            label: ['corporate Card number', '收款账号'],
            placeholder: ['Please enter corporate Card number', '请输入卡号']
          },
          place: {
            label: ['The region of opening corporate', '开户行所在地'],
            placeprovince: ['Please select the province', '请选择所在省份'],
            placecity: ['Please select the city', '请选择所在城市']
          },
          corporate: {
            label: ['Opening corporate', '收款银行'],
            placeholder: ['Please enter Opening branch', '请选择收款银行']
          },
          branch: {
            label: ['Opening branch', '开户支行'],
            placeholder: ['Please enter Opening branch', '请输入开户支行']
          }
        },
        paypal: {
          name: ['PayPal', 'PayPal'],
          introduce: [
            'USD only(3% handling fee for USD payment).',
            '仅美元付款(美元付款需收取3%手续费)。'
          ],
          paypal: {
            label: ['Paypal', 'Paypal'],
            placeholder: ['Please enter Paypal account', '请输入Paypal账号']
          }
        },
        payoneer: {
          name: ['Payoneer', 'Payoneer'],
          introduce: [
            'USD only (The minimum amount of settlement is $50).',
            '仅限美元(最低结算金额为50美元)'
          ],
          payoneer: {
            label: ['Payoneer', 'Payoneer'],
            placeholder: ['Please enter Payoneer account', '请输入Payoneer账号']
          }
        },
        overseas: {
          name: ['Overseas bank card', '境外银行卡'],
          skxm: {
            label: ['Payee Name', '收款人姓名'],
            placeholder: ['Please enter the payee name', '请输入收款人姓名']
          },
          skzhmc: {
            label: ['Account Name', '收款账户名称'],
            placeholder: ['Please enter account name', '请输入收款账户名称']
          },
          skzh: {
            label: ['Account Number', '收款账户'],
            placeholder: ['Please enter account number', '请输入收款账户']
          },
          skkhhFh: {
            label: ['Bank & Branch', '开户行及分行'],
            placeholder: ['Please enter bank and branch', '请输入开户行及分行']
          },
          skhszd: {
            label: ['Bank Location', '收款行所在地'],
            placeholder: ['Please enter bank location', '请输入收款行所在地']
          },
          zhlx: {
            label: ['Account Type', '账户类型'],
            placeholder: ['Please enter account type', '请输入账户类型']
          },
          gjYb: {
            label: ['Country & Postcode', '国家、邮编'],
            placeholder: ['Please enter country and postcode', '请输入国家、邮编']
          },
          jzcsJzjd: {
            label: ['City & Street', '居住城市、街道'],
            placeholder: ['Please enter city and street', '请输入居住城市、街道']
          },
          wzjzdz: {
            label: ['Full Address', '完整居住地址'],
            placeholder: ['Please enter full address', '请输入完整居住地址']
          },
          swift: {
            label: ['SWIFT Code', 'SWIFT代码'],
            placeholder: ['Please enter SWIFT code', '请输入SWIFT代码']
          },
          skbz: {
            label: ['Currency', '收款币种'],
            placeholder: ['Please enter currency', '请输入收款币种']
          }
        },
        paymentMethod: {
          gdg: ['B2B (Business to Business)', '公对公'],
          lxlw: ['continuous service', '连续劳务'],
          yblw: ['General labor services', '一般劳务'],
          jnyh: ['Domestic bank card', '境内银行卡'],
          jwyh: ['Overseas bank card', '境外银行卡'],
        },
      },

      // 客户端
      XQLayout: {
        customerService: ['customer service', '客服'],
        overview: ['Overview', '概览页'],
        online: ['Messages', '在线沟通'],
        basic: ['My Information', '基本信息'],
        project: ['Demand management', '任务管理'],
        projectPost: ['Post demand', '任务发布'],
        delivery: ['Resume Delivery', '简历投递'],
        offer: ['Order Management', '订单管理'],
        offerList: ['Order List', '订单列表'],
        Appeal: ['Appeal Management', '申诉管理'],
        evaluate: ['Evaluate Management', '评价管理'],
        // project:['Project Management','项目管理'],
        people: ['Personnel Management', '人才管理'],
        setting: ['Settings', '安全设置'],
        messagefeedback: ['Notifications', '我的消息'],
        logout: ['Logout', '退出登录'],
        changetype: ['Job search', '找工作'],
        yes: ['Yes', '确定'],
        no: ['No', '取消'],
        login: ['login successfully', '登录成功!'],
        loginoutsucess: ['Exit successfully', '退出成功!'],
        loginouterror: ['Exit failure', '退出失败!'],
        confirmloginout: ['Confirm logout?', '确认退出登录？']
      },
      // 概览页
      XQOverview: {
        name: ['Overview', '概览页'],
        banner: {
          welcome: ['Welcome to', '欢迎来到'],
          global: [
            'Global Services Massive Translators',
            '全球服务大型翻译公司'
          ],
          learn: ['Learn More', '学习更多']
        },
        operating: ['Operating instructions', '步骤图'],
        publish: ['Projects accomplished', '任务数量'],
        resume: ['Projects delivered', '投递数量'],
        personalinfo: ['Personal information', '基本信息'],
        essentialinfo: ['Basic Information Filling', '完善基本信息'],
        jobposting: ['Job Posting', '发布任务'],
        resumescreen: ['Resume Screening', '筛选简历'],
        cooperation: ['Cooperation', '达成合作']
      },
      // 消息通知
      XQMessagefeedback: {
        name: ['Notifications', '我的消息'],
        tablabel: {
          notification: ['Recent News', '消息通知'],
          feedback: ['Feedback', '反馈意见']
        },
        notification: {
          allread: ['All read', '全部已读'],
          read: ['Read', '已读'],
          unread: ['Unread', '未读']
        },
        feedback: {
          feedback: ['Feedback', '反馈意见'],
          read: ['Read', '已读']
        },
        type: {
          label: ['Feedback Type', '反馈类型']
        },
        time: {
          label: ['Feedback Time', '反馈时间']
          // place:['Feedback Type','反馈类型'],
        },
        instructions: {
          label: ['Feedback Instructions', '反馈说明'],
          place: ['Please enter Feedback Instructions', '请输入反馈说明']
        },
        status: {
          label: ['Feedback Status', '反馈状态']
          // place:['Feedback Type','反馈类型'],
        },
        operation: {
          label: ['Operation', '操作']
          // place:['Feedback Type','反馈类型'],
        },
        detail: ['Details', '任务详情'],
        select: ['Select', '选择'],
        returns: ['Cancel', '取消'],
        submit: ['Submit', '提交'],
        attachments: ['Relevant attachments', '相关附件'],
        self: ['Self-evaluation', '自我评价']
      },
      // 在线客服
      XQServiceOnline: {
        name: ['Messages', '在线沟通'],
        place: {
          search: ['Please enter user name to query', '请输入用户姓名']
        },
        whole: ['All', '全部'],
        read: ['Read', '已读'],
        unread: ['Unread', '未读'],
        file: ['[ file ]', '[ 文件 ]'],
        photo: ['[ picture ]', '[ 图片 ]'],
        card: ['[ project card ]', '[ 任务卡片 ]'],
        resume: ['Resume', '简历'],
        hire: ['hire', '雇佣'],
        writemsg: ['Write a message…', '输入信息…']
      },
      // 在线联系
      XQOnline: {
        name: ['Messages', '在线沟通'],
        place: {
          search: ['Please enter user name to query', '请输入用户姓名']
        },
        whole: ['All', '全部'],
        read: ['Read', '已读'],
        unread: ['Unread', '未读'],
        file: ['[ file ]', '[ 文件 ]'],
        photo: ['[ picture ]', '[ 图片 ]'],
        card: ['[ project card ]', '[ 任务卡片 ]'],
        resume: ['Resume', '简历'],
        hire: ['hire', '雇佣'],
        writemsg: ['Write a message…', '输入信息…'],
        type3: ['[ Withdrew a message ]', '[ 撤回了一条消息 ]'],
        type4: ['[ Order Information Card ]', '[ 订单信息卡片 ]'],
        type5: ['[ Commissioned Service Card ]', '[ 委托服务卡片 ]'],
        type6: ['[ Task Information Card ]', '[ 任务信息卡片 ]'],
        type7: ['[ Customer Service Reminder ]', '[ 客服温馨提示 ]'],
        type0: ['[ No news ]', '[ 暂无消息 ]']
      },
      // 简历详情
      XQResume: {
        name: ['Resume Detail', '简历详情'],
        location: ['Location', '所在地'],
        phone: ['Phone', '电话'],
        email: ['Email', '邮箱'],
        basic: ['Basic Information', '基础信息'],
        country: ['Country & Region', '国家/地区'],
        nativelanguage: ['Native language', '母语'],
        languageskills: ['Language skill', '擅长语种'],
        translation: ['Translation experience', '翻译年限'],
        area: ['Fields', '擅长领域'],
        languageoutput: ['Languages and Translation Output', '语种及产量'],
        wordday: ['Words/Day', '字/天'],
        wordweek: ['Words/Week', '字/周'],
        languagecertificate: ['Language Certificate', '语言证书'],
        language: ['Languages', '语种'],
        certificatename: ['Certificate name', '证书'],
        level: ['Certificate level', '水平等级'],
        workhistory: ['Employment History', '工作经历'],
        companyname: ['Company name', '公司名称'],
        workduration: ['Duration', '工作时间'],
        position: ['Position', '职位名称'],
        description: ['Job description', '职位描述'],
        projectexperience: ['Project Experience', '项目经历'],
        projectname: ['Name', '项目名称'],
        projectduration: ['Duration', '项目时间'],
        projectdescription: ['Project description', '项目描述'],
        self: ['Self-evaluation', '个人评价']
      },
      XQBasic: {
        name: ['Basic Information', '基本信息'],
        myinfo: ['My information', '个人信息'],
        realname: ['Name', '真实姓名'],
        phone: ['Phone number', '手机号码'],
        compony: ['Company ', '公司名称'],
        email: ['Email ', '邮箱号码'],
        wechat: ['WeChat ID', '微信号码'],
        otherinfo: ['Other contact information', '其他联系方式'],
        country: ['Country & Region', '国家/地区'],
        personalprofile: ['Personal profile', '个人简介'],
        location: ['Location', '所在地'],
        compony: ['Compony', '公司名称'],
        realauth: ['Authentication', '认证信息'],
        nameidcard: ['Name on ID card', '证件姓名'],
        noidcard: ['ID card No.', '证件号码'],
        fileidcard: ['ID card photo', '证件附件'],
        passportname: ['Name on passport', '护照姓名'],
        passportno: ['Passport No.', '护照号码'],
        passportfile: ['Passport photo', '护照附件'],
        return: ['Cancel', '取消'],
        submit: ['Submit', '提交'],
        select: ['Select', '选择'],
        // aaa:['',''],
        place: {
          realname: ['Please enter name', '请输入真实姓名'],
          country: ['Please select country & region', '请选择国家/地区'],
          wechat: ['Please enter WeChat ID', '请输入微信'],
          other: [
            'Please enter other contact information',
            '请输入其他联系方式'
          ],
          location: ['Please enter Location', '请输入所在地'],
          compony: ['Please enter Compony', '请输入公司名称'],
          personal: ['Please enter personal profile', '请输入个人简介'],
          type: ['Type', '证件类型'],
          idcard: ['ID card', '身份证'],
          passport: ['Passport', '护照'],
          idname: ['Please enter Name on ID card', '请输入证件姓名'],
          passportname: [
            'Please enter name on your  passport ',
            '请输入护照姓名'
          ],
          idno: ['Please enter ID No', '请输入证件号码'],
          passportno: ['Please enter passport No.', '请输入护照号码'],
          photo: [
            'Please upload the photos of your ID card/your passport.',
            '请上传你的身份证/护照图片'
          ]
        }
      },
      XQProjectindex: {
        name: ['Post demand', '任务发布'],
        place: {
          projectnum: [
            'Please enter the project No. to query',
            '请输入任务编号'
          ],
          projectType: [
            'Please enter the project type. to query',
            '请输入任务类型'
          ],
          projectCreationTime: [
            'Please enter the project time. to query',
            '请输入任务发布时间'
          ],
          projectName: [
            'Please enter the project name. to query',
            '请输入任务名称'
          ]
        },
        whole: ['All', '全部'],
        recruit: ['Recruiting', '招募中'],
        open: ['Opend', '已开启'],
        finish: ['Finished', '已结束'],
        added: ['Add', '新增'],
        projectnum: ['No.', '任务编码'],
        projectReleaseInforId: ['Position Id', '任务编号'],
        projectname: ['Name', '任务名称'],
        projecttype: ['Type', '任务类型'],
        projectstatus: ['Status', '任务状态'],
        delivery: ['Deliveries', '任务投递(份)'],
        visitor: ['Views', '浏览人次(次)'],
        release: ['Release date', '发布时间'],
        expirationStart: ['Due date', '开始时间'],
        expiration: ['Due date', '结束时间'],
        operation: ['Operation', '操作'],
        revise: ['revise', '修改']
      },
      // 申诉管理 需求
      XQAppealmanagement: {
        name: ['Appeal management', '申诉管理'],

        ComplaintNumber: ['Complaint number', '申诉编号'],
        OrderNumber: ['Order number', '订单编号'],
        TypeOfAppeal: ['Type of appeal', '申诉类型'],
        AppealStatus: ['Appeal status', '申诉状态'],
        AppealStartTime: ['Appeal start time', '申诉开始时间'],
        AppealClosingTime: ['Appeal closing time', '申诉结束时间'],
        CauseOfAppeal: ['Cause of appeal', '申诉事由'],

        place: {
          projectOrderId: ['Please enter the order number', '请输入订单编号'],
          AppealTime: ['Please enter the appeal time', '请输入申诉时间'],
          AppealStatus: ['Please enter the appeal status', '请输入申诉状态']
        },
        supUserName: ['supUserName', '供应商名称'],
        operation: ['operation', '操作'],
        details: ['details', '详情'],

        detailView: {
          projectOrderAppealId: ['Complaint number', '申诉编号'],
          projectOrderId: ['Order number', '订单编号'],
          orderName: ['Order name', '订单名称'],
          appealType: ['Type of appeal', '申诉类型'],
          reasonForAppeal: ['Cause of appeal', '申诉事由'],
          appealStatus: ['Appeal status', '申诉状态'],
          appealStartTime: ['Appeal start time', '申诉开始时间'],
          appealEndTime: ['Appeal closing time', '申诉结束时间'],
          appealResults: ['Application result', '申诉结果'],
          processedBy: ['Handler', '处理人'],

          appealEvidenceFile: ['Grievance evidence', '申诉证据附件'],
          appealResultsFile: ['Application result', '申诉结果附件']
        }
      },
      // 评价管理 需求
      XQEvaluateManagement: {
        name: ['Appeal management', '评价管理'],

        ComplaintNumber: ['Complaint number', '申诉编号'],
        OrderNumber: ['Order number', '订单编号'],
        TypeOfAppeal: ['Type of appeal', '申诉类型'],
        AppealStatus: ['Appeal status', '申诉状态'],
        AppealStartTime: ['Appeal start time', '申诉开始时间'],
        AppealClosingTime: ['Appeal closing time', '申诉结束时间'],
        CauseOfAppeal: ['Cause of appeal', '申诉事由'],

        place: {
          evaluateUserNameLike: [
            'Please enter the name of the person being evaluated',
            '请输入被评价人名称'
          ]
        },
        supUserName: ['supUserName', '供应商名称'],
        operation: ['operation', '操作'],
        details: ['details', '详情'],

        detailView: {
          projectOrderAppealId: ['Complaint number', '申诉编号'],
          projectOrderId: ['Order number', '订单编号'],
          orderName: ['Order name', '订单名称'],
          appealType: ['Type of appeal', '申诉类型'],
          reasonForAppeal: ['Cause of appeal', '申诉事由'],
          appealStatus: ['Appeal status', '申诉状态'],
          appealStartTime: ['Appeal start time', '申诉开始时间'],
          appealEndTime: ['Appeal closing time', '申诉结束时间'],
          appealResults: ['Application result', '申诉结果'],
          processedBy: ['Handler', '处理人'],

          appealEvidenceFile: ['Grievance evidence', '申诉证据'],

          appealResultsFile: ['Application result', '申诉结果']
        }
      },

      // 订单管理 需求
      XQOfferManagement: {
        name: ['Order List', '订单列表'],
        place: {
          supUserName: [
            'Please enter the supplier name to query',
            '请输入供应商名称'
          ],
          projectOrderId: [
            'Please enter the project No. to query',
            '请输入订单编号'
          ],
          orderName: [
            'Please enter the project name. to query',
            '请输入订单名称'
          ],
          startTime: [
            'Please enter the project time. to query',
            '请输入开始时间'
          ],
          endTime: ['Please enter the end time. to query', '请输入结束时间'],
          orderStatus: [
            'Please enter the order status. to query',
            '请输入订单状态'
          ]
        },
        supUserName: ['supUserName', '供应商名称'],
        supUserId: ['supUserId', '供应商编号'],
        projectOrderId: ['projectOrderId', '订单编号'],
        orderName: ['orderName', '订单名称'],
        projectReleaseInforId: ['projectReleaseInforId', '任务编号'],
        orderStatus: ['orderStatus', '订单状态'],
        deliverTime: ['deliverTime', '交付时间'],
        actualEndTime: ['actualEndTime', '验收时间'],
        createByName: ['createByName', '创建人'],
        startTime: ['startTime', '开始时间'],
        workload: ['workload', '工作量'],
        unitPrice: ['unitPrice', '单价'],
        unitName: ['unitName', '单位'],
        amountOfMoney: ['amountOfMoney', '订单金额'],
        OrderPaymentAmount: ['Order payment amount', '支付金额'],
        commissionXQ: ['commissionXQ', '订单手续费'],
        orderType: ['orderType', '订单类型'],
        whFieldId: ['whFieldId', '专业领域'],
        sourceLanguage: ['whFieldId', '源语种'],
        targetLanguage: ['targetLanguage', '目标语种'],

        operationField: {
          send: ['send', '已发送'],
          receive: ['receive', '已接收'],
          rejection: ['rejection', '已拒收'],
          start: ['start', '启动中'],
          end: ['end', '已结束'],
          appeal: ['appeal', '申诉中']
        },
        revise: ['revise', '修改'],
        operation: ['Operation', '操作'],

        operationAdd: {
          edit: ['edit', '修改'],
          payment: ['payment', '付款'],
          result: ['result', '验收成果'],
          appeal: ['appeal', '申诉'],
          evaluate: ['evaluate', '评价']
        },
        checkList: [
          [
            'Project No.',
            'Supplier No.',
            'Workload',
            'Unit price',
            'Unit',
            'Order amount',
            'Order handling fee'
          ],
          [
            '任务编号',
            '需求人编号',
            '工作量',
            '单价',
            '单位',
            '订单金额',
            '订单手续费'
          ]
        ],
        // 评价
        evaluate: {
          evaluateGrade: ['evaluate grade', '评价星级'],
          evaluateDescription: ['evaluate description', '评价描述']
        },
        // 申诉
        appeal: {
          appealType: ['Type of appeal', '申诉类型'],
          reasonForAppeal: ['Cause of appeal', '申诉事由'],
          appealEvidenceFile: ['Evidence attachment', '证据附件']
        },
        // 验收信息弹窗
        deliverable: {
          orderInformation: ['order information', '订单信息'],
          orderReference: ['order reference', '订单编号'],
          OrderName: ['Order name', '订单名称'],
          supName: ['name of the supplier', '需求人名称'],
          sourceLanguage: ['Source language', '源语种'],
          targetLanguage: ['Target language', '目标语种'],
          createTime: ['create time', '创建时间'],
          deliverTime: ['deliverTime', '交付时间'],
          actualEndTime: ['actualEndTime', '验收时间'],
          orderDescription: ['orderDescription', '订单详情'],
          OrderTypes: ['Order types', '订单类型'],
          whField: ['Field', '专业领域'],
          startTime: ['start time', '开始时间'],
          endTime: ['end time', '结束时间'],
          upload: ['Results upload', '成果展示'],
          file: ['Delivery document', '交付文件'],
          description: ['Delivery description', '交付说明'],

          Payment: ['Payment amount confirmation', '支付金额确认'],
          workload: ['workload', '工作量'],
          unitPrice: ['Unit/Price', '单价/单位'],
          totalprices: ['total prices', '订单金额'],
          serviceharge: ['service charge', '订单手续费'],
          totalamount: ['Total amount', '支付金额'],

          resultsUpload: ['Results upload', '成果展示'],
          deliverFile: ['Delivery document', '交付文件'],
          deliverDescription: ['Delivery description', '交付说明']
        },
        // 付款信息 弹窗
        payment: ['Select billing method', '选择计费方式'],
        wechat: {
          name: ['WeChat Pay', '微信支付'],
          introduce: ['Use wechat Pay', '使用微信支付结算']
        },
        zfb: {
          name: ['Alipay Pay', '支付宝支付'],
          introduce: ['Use Alipay Pay', '使用支付宝支付结算']
        },

        // payment:{
        //     paymentTitle:['Select billing method','选择计费方式'],
        //     bank:{
        //         name:['Chinese bank card','中国银行卡'],
        //         introduce:['Use a Chinese bank card','使用中国银行卡结算'],
        //     },
        //     gongshangYH:{
        //         name:['Industrial and Commercial Bank of China','中国工商银行'],
        //         introduce:['Use a Industrial and Commercial Bank of China card','使用工商银行结算'],
        //     },
        //     zhaoshangYH:{
        //         name:['China Merchants Bank','中国招商银行'],
        //         introduce:['Use a China Merchants Bank card','使用招商银行卡结算'],
        //     },
        //     CompletedPayment:['Completed payment','已完成支付'],
        //     OutstandingPayment:['Outstanding payment','未完成支付'],
        // },

        affirmPayment: ['Confirm payment', '确认支付'],
        delivery: ['Confirm delivery', '确认验收'],
        payment: ['payment', '支付方式'],
        close: ['close', '关闭'],
        select: ['select', '上传']
      },
      XQInitiateAnOrder: {
        name: ['initiateAnOrder', '订单'],
        userTitle: ['', '需求人信息'],
        supUserName: ['supUserName', '供应商信息'],
        country: ['Country & Region', '国家/地区'],
        nativelanguage: ['Native language', '母语'],
        languageskills: ['Language skill', '擅长语种'],
        area: ['Area of expertise', '专业领域'],

        OrderInfomation: ['Order Information', '订单信息'],
        OrderName: ['Order name', '订单名称'],
        orderNumber: ['Order number', '订单编号'],
        OrderTypes: ['Order types', '订单类型'],
        SourceLanguage: ['Source language', '源语种'],
        createTime: ['Create time', '创建时间'],
        deliverTime: ['Delivery time', '交付时间'],
        actualEndTime: ['Actual end time', '验收时间'],
        TargetLanguage: ['Target language', '目标语种'],
        startTime: ['start time', '开始时间'],
        endTime: ['end time', '结束时间'],

        whFieldId: ['professional field', '专业领域'],
        OrderFile: ['Order file', '订单文件'],
        deliverFile: ['deliver file', '交付文件'],
        select: ['select', '上传'],
        choice: ['choice', '选择'],
        orderIllustration: ['order illustration', '订单说明'],

        projectInfo: {
          projectReleaseInforId: ['Position Id', '任务编号'],
          projectname: ['Position name:', '任务名称：'],
          CompanyName: ['Company name:', '公司名称：'],
          projecttype: ['Type', '任务类型'],
          projectstatus: ['Status', '任务状态'],
          release: ['Release date', '发布时间'],
          expiration: ['Due date', '到期时间'],
          area: ['Fields: ', '擅长领域：'],
          SourceLanguage: ['Source language', '源语种'],
          TargetLanguage: ['Target language', '目标语种']
        },

        OrderInfoRules: {
          OrderName: ['Order name', '请输入订单名称'],
          orderNumber: ['Order number', '请输入订单编号'],
          deliverTime: ['deliverTime', '请输入交付时间'],
          actualEndTime: ['actualEndTime', '请输入验收时间'],
          OrderTypes: ['Order types', '请输入订单类型'],
          SourceLanguage: ['Source language', '请输入源语种'],
          TargetLanguage: ['Target language', '请输入目标语种'],
          startTime: ['start time', '请输入开始时间'],
          endTime: ['end time', '请输入结束时间'],
          whFieldId: ['professional field', '请输入专业领域'],
          OrderFile: ['Order file', '订单文件'],
          orderIllustration: ['order illustration', '请输入订单说明'],
          UnitPrice: ['UnitPrice', '请输入单价或单位'],
          unit: ['UnitPrice', '请输入单位'],
          price: ['UnitPrice', '请输入单价'],
          workload: ['workload', '请输入工作量']
        },
        projectPlace: {
          projectnum: [
            'Please enter the project No. to query',
            '请输入任务编号'
          ],
          projectType: [
            'Please enter the project type. to query',
            '请输入任务类型'
          ],
          projectCreationTime: [
            'Please enter the project time. to query',
            '请输入任务发布时间'
          ],
          projectName: [
            'Please enter the project name. to query',
            '请输入任务名称'
          ]
        },

        orderAmount: ['Order amount', '订单金额'],
        workload: ['workload', '工作量'],
        UnitPrice: ['Unit/Price', '单价/单位'],
        unit: ['unit', '单位'],
        price: ['price', '单价'],
        money: ['money', '订单金额'],
        serviceharge: ['service charge', '订单手续费'],
        totalprices: ['total prices', '支付金额'],

        return: ['Cancel', '返回'],
        submit: ['Submit', '提交']
      },
      XQResumeDelivery: {
        name: ['Resume Delivery', '简历投递'],
        place: {
          projectnum: [
            'Please enter the project No. to query',
            '请输入投递人号码'
          ],
          projectNameLike: [
            'Please enter the project No. to query',
            '请输入任务名称'
          ],
          supNameLike: [
            'Please enter the project No. to query',
            '请输入投递人'
          ],
          projectNumber: ['Please enter the project number', '请输入任务编号'],
          createByName: [
            'Please enter the project No. to query',
            '请输入发布人名称'
          ],
          dateTime: ['Please enter the project No. to query', '请输入任务名称']
        },
        languageskills: ['Language skill:', '擅长语种：'],
        whole: ['All', '全部'],
        recruit: ['Recruiting', '招募中'],
        open: ['Opend', '已开启'],
        finish: ['Finished', '已结束'],
        added: ['Add', '新增'],
        projectnum: ['No.', '任务编码'],
        projectReleaseInforId: ['Position Id', '任务编号'],
        projectname: ['Position name:', '任务名称：'],
        CompanyName: ['Company name:', '公司名称：'],
        projecttype: ['Type', '任务类型'],
        projectstatus: ['Status', '任务状态'],
        delivery: ['Deliveries', '任务投递(份)'],
        visitor: ['Views', '浏览人次(次)'],
        release: ['Release date', '发布时间'],
        expiration: ['Due date', '到期时间'],
        operation: ['Operation', '操作'],
        revise: ['revise', '修改'],
        country: ['Country & Region: ', '国家/地区：'],
        sex: ['Gender: ', '性别：'],
        sexNull: ['unknown', '未知'],
        age: ['Age: ', '年龄：'],
        ageNull: ['unknown', '未知'],
        experience: ['Experience: ', '翻译年限：'],
        degree: ['Degree: ', '学历：'],
        label: ['Native language: ', '母语：'],
        area: ['Fields: ', '擅长领域：'],

        Hire: ['Hire', '雇佣'],
        Chat: ['Chat', '聊天'],
        Collect: ['Collect', '收藏'],
        Matching: ['Matching', '匹配']
      },
      XQPositionAE: {
        name: ['Add/Edit position', '新增/编辑任务'],
        positionname: ['Position Name', '任务名称'],
        positionstatus: ['Position status', '任务状态'],
        projecttype: ['Position type', '任务类型'],
        area: ['Area of expertise', '专业领域'],
        source: ['Source language', '源语种'],
        target: ['Target language', '目标语种'],
        deadlineStart: ['Start Time', '开始时间'],
        deadline: ['End Time', '结束时间'],
        workload: ['Projected workload', '预计工作量'],
        salary: ['Salary', '薪酬'],
        detail: ['Remarks', '备注'],
        instructions: ['Delivery instructions', '详情说明'],
        return: ['Cancel', '返回'],
        submit: ['Submit', '提交'],
        projectPhone: ['Contact Information', '联系方式'],
        region: ['region', '地区'],
        place: {
          positionname: ['Please enter Position name', '请输入任务名称'],
          positionstatus: ['Please select position status', '请选择任务状态'],
          projecttype: ['Please select position type', '请选择任务类型'],
          area: ['Please select type', '请选择专业领域'],
          source: ['Please select source language', '请选择源语种'],
          target: ['Please select target language', '请选择源语种'],
          deadline: ['Please select project deadline', '请选择任务截止时间'],
          workload: ['Please enter projected workload', '请输入预计工作量'],
          salary: ['Please enter salary', '请输入薪酬'],
          detail: ['Please enter remarks', '请输入备注'],
          projectPhone: ['Please enter your contact information', '请输入联系方式'],
          region: ['Please enter the region', '请输入地区']
        }
      },
      XQPositionAll: {
        placeholder: {
          jobdetails: ['Job Details', '任务详情']
        },
        place: {
          projectnum: ['Please enter the project No. to query', '请输入项编号'],
          translatorname: ['Translator', '请输入译员姓名'],
          area: ['Area of expertise', '请输入专业领域'],
          label: ['Native language', '请输入母语'],
          experience: ['Translation experience', '请输入翻译年限'],
          language: ['Language skill', '请输入擅长语种']
        },
        step: {
          projectdetail: ['Position Details', '任务详情'],
          resume: ['Resume', '简历投递']
        },
        jobdetails: {
          name: ['Job Details', '任务详情'],
          online: ['Messages', '在线沟通'],
          jobno: ['No.', '任务编号'],
          description: ['Project Description', '任务描述'],
          projectname: ['Name', '任务名称'],
          language: ['Languages', '语种'],
          status: ['Status', '任务状态'],
          requirements: ['Project Requirements', '任务要求'],
          estimatedoutput: ['Estimated Effort', '预估工作量'],
          //   estmateddate:['Estimated Date of Submission','预估提交时间'],
          estmateddateStart: ['Start Time ', '开始时间'],
          estmateddate: ['End Time ', '结束时间'],
          releaseTime: ['Release Time', '发布时间'],
          projectcontent: ['Remarks', '备注'],
          salary: ['Salary', '薪酬'],
          iphone: ['Iphone', '联系方式'],
          note: ['Delivery Instructions', '详情说明'],
          whField: ['Fields', '专业领域'],
          qrcode: ['QR code', '二维码'],
          projectType: ['Type', '任务类型'],
          resumeinfo: ['Contact Information', '联系人信息'],
          address: ['Address', '地址'],
          email: ['Email', '邮箱'],
          phone: ['Phone', '电话'],
          briefIntroduction: ['Brief Introduction', '简介'],
          copeTxt: [
            'Successfully copied sharing link to clipboard!',
            '已成功复制分享链接到剪贴板!'
          ],
          apply: ['Apply', '立即投递'],
          applied: ['Applied', '已申请']
        },
        detail: {
          browse: ['Browse', '浏览'],
          send: ['Send', '投递'],
          number: ['Position Number', '任务编号'],
          projectReleaseInforId: ['Position Id', '任务编号'],
          name: ['Position Name', '任务名称'],
          type: ['Position Type', '任务类型'],
          status: ['Position Status', '任务状态'],
          source: ['Source Language', '源语种'],
          target: ['Target Language', '目标语种'],
          area: ['Area of expertise', '专业领域'],
          workload: ['Projected workload', '预计工作量'],
          salary: ['Salary', '薪酬'],
          apply: ['Apply', '申请'],
          applied: ['Applied', '已申请'],
          deadlineStart: ['Start Time', '开始时间'],
          deadline: ['End Time', '结束时间'],
          detail: ['Remarks', '备注'],
          instructions: ['Delivery instructions', '详情说明'],
          qrcode: ['QR code', '二维码'],
          share: ['Share', '分享'],
          copeTxt: [
            'Successfully copied sharing link to clipboard!',
            '已成功复制分享链接到剪贴板!'
          ]
        },
        resume: {
          language: ['Language skill', '擅长语种'],
          experience: ['Translation experience', '翻译年限'],
          unknown: ['Unknown', '未知'],
          degree: ['Degree', '学历'],
          management: ['Communication management', '沟通任务'],
          time: ['Delivery time', '投递时间'],
          applyrecordName: ['Application Record', '申请记录']
        },
        management: {
          name: ['Personnel Management', '人才管理'],
          whole: ['All', '全部'],
          read: ['Read', '已读简历'],
          unread: ['Unread', '未读简历'],
          collect: ['Collected', '收藏简历']
        }
      },
      XQPeople: {
        name: ['Application project record', '申请任务记录'],
        number: ['Project Code', '任务编号'],
        projectname: ['Name', '任务名称'],
        date: ['Application Date', '申请时间']
      },
      XQLogin: {
        bannerwelcome: ['Welcome to', '欢迎来到'],
        bannerglobal: ['Global Services ', '全球服务'],
        bannerabundant: ['Abundant Resources', '丰富资源'],
        bannertext: [
          'Here’s a sea of native and professional translators. Join us now.',
          '这里有一批本土和专业的翻译人员。现在就加入我们，开始新的翻译生涯。'
        ],
        bannertext2: [
          'On Yedeer, native language translation and proofreading of worldwide languages can be perfectly accomplished with a sea of translators, spanning more than 80 languages of Chinese to foreign, English to foreign, and foreign to foreign translation.',
          '我们拥有大量的翻译人员，可以实现全球语言的母语翻译和校对，涵盖中译外、英译外、外译外80多种语言。'
        ],

        login: ['Login', '登录'],
        resetpass: ['Reset password', '重置密码'],

        please: ['Please enter your account information', '请输入您的账户信息'],
        afraid: [
          "Don't be afraid to forget your password.",
          '不要害怕忘记密码。'
        ],
        newpass: ['Please create your new password.', '请创建新密码。'],
        register: ['Register an account below.', '在注册页面注册你的账户'],

        confirmreset: ['Confirm reset', '重置密码'],
        account: ['Account No.', '账号'],
        createpass: ['Create password', '创建密码'],
        createpasslabel: ['Please enter password', '请输入密码'],
        accountlabel: ['Please enter phone number/email', '请输入手机号/邮箱'],
        password: ['Password', '密码'],
        passwordlabel: ['Please enter password', '请输入密码'],
        forgetpassword: ['Forgot password？', '忘记密码？'],
        //
        enternewpass: ['Enter new password', '新密码'],
        enternewpasslabel: ['Please enter new password', '请输入新密码'],
        confirmpass: ['Confirm password', '确认新密码'],
        confirmpasslabel: ['Please enter password again', '请再次输入你的密码'],

        codelogin: ['Verification code login', '验证码登录'],
        pleasecode: ['Please enter verification code', '请输入验证码'],
        getcode: ['Get verification code', '获取验证码'],
        passlogin: ['Password login', '密码登录'],
        newuser: ['New user?', '新用户？'],
        signup: ['Sign up', '注册'],
        code: ['Verification code', '验证码'],
        yqm: {
          label: ['Invitation code', '邀请码'],
          place: ['Please enter invitation code', '请输入邀请码']
        },
        slide: ['Please slide to verify', '请滑动滑块验证'],
        verified: ['Verified', '验证成功'],
        next: ['Next', '下一步'],
        haveaccount: ['Already have an account？', '已经拥有账户？']
      },
      //首页官网
      officialWebsite: {
        home: ['home', '首页'],
        aboutYedeer: ['About Yedeer', '关于Yedeer'],
        signUp: ['Sign Up', '注册'],
        login: ['Login', '登录'],
        bannerwelcome: ['Welcome to', '欢迎进入'],
        bannerglobal: ['Global Services', '全球服务'],
        bannerinfinite: ['Infinite Opportunities', '无限机遇'],
        start: ['Get Started', '开始'],
        bannerbring: ['brings you into a world of languages', '带你'],
        bannerlanguages: ['into a world of languages', '领略语言的魅力'],
        welcome: [
          'Welcome to Yedeer. There are various projects to be translated here, involving more than 80 languages. You can work anywhere at any time. Join us now and start your new translation career.',
          '欢迎进入Yedeer！这里有各种各样的待翻译项目，涉及80多种语言，供您随时随地进行选择，立即加入我们，开始您的翻译之旅吧！'
        ],
        works: ['HOW IT WORKS', '工作模式'],
        joinUs: ['Join us', '加入我们'],
        opportunities: [
          'Sign up to receive your own Yedeer account, which will give you access to our freelance work opportunities, whenever and wherever you are.',
          '注册即可获得个人Yedeer账户，无论何时何地，您都可以成为自由职业者！'
        ],
        LanguageTest: ['Language test', '语言测试'],
        required: [
          'An online or offline language foundation test is required.',
          '需要在线或离线完成语言基础测试。'
        ],
        freelance: ['Search for freelance jobs', '自由职业。'],
        search: [
          'Search for the project that suits you, look at project descriptions, rates, requirements and apply.',
          '查找您擅长的项目，查看项目描述、费率、要求并申请。'
        ],
        member: ['Be a member of Yedeer team', '加入Yedeer'],
        collaborators: [
          'Join our global community and become our collaborators',
          '加入我们的全球社区，成为我们的合作伙伴。'
        ],
        why: ['Why Us?', '为什么我们是您的称心之选？'],
        getJob: ['Get a job offer for free', '免费获得工作'],
        access: [
          'You have access to various project demands for free and can easily participate in these projects.',
          '您可以免费访问各种项目需求，并轻松参与这些项目。'
        ],
        settlement: [
          'More job opportunities, easy settlement',
          '众多工作、结算方便'
        ],
        projects: [
          'A large number of projects are updated anytime. You can submit finished project to apply for settlement. Yedeer supports settlement by CNY (China UnionPay) or USD (Paypal, Payoneer).',
          '大量项目随时更新。您提交已完成的项目后可以申请结算。Yedeer支持人民币（中国银联）或美元（Paypal、Payoneer）结算。'
        ],
        fragmented: ['Work with fragmented time', '充分利用零碎时间'],
        partTimeJobs: [
          'Yedeer supports collaboration of part-time jobs. Your work amount will be recorded in real time so you can make full use of your fragmented time to make more profits.',
          'Yedeer支持兼职模式，实时记录工作量，这样您就可以充分利用零碎时间来获得更多的收益。'
        ],
        anywhere: ['Work anywhere, anytime', '随时随地工作'],
        discretion: [
          'You can work anywhere and anytime, all at your discretion.',
          '您可以选择在任何时间、任何地点进行工作，一切由您决定。'
        ],
        upToDate: ['Recent Jobs', '最新需求'],
        interpretation: ['interpretation', '口译'],
        translate: ['translate', '笔译'],
        listen: ['Listen to our translators', '我们译员的心声'],
        follow: ['Follow us', '关注我们'],
        phone: ['Contact Us', '电话'],
        facebook: ['Facebook', '飞书'],
        email: ['Email', '邮箱'],
        wechat: ['WhatsApp/Telegram/WeChat', '微信'],
        introductionOne: [
          'Welcome to Yedeer. There are a large number of translation projects, involving more than 80 languages in the world, and you can work whenever and wherever you want.',
          '欢迎来到Yedeer！这里有大量的翻译项目，涉及80多种语言，供您随时随地进行选择。'
        ],
        introductionTwo: [
          'Yedeer is an international translation service platform independently developed by Besesun Information Technology Co., Ltd. It focuses on providing full-time and part-time translation jobs for global multilingual talents, and online value-added services for domestic and foreign language workers. The platform can provide you with a large number of multilingual interpretation and translation projects.',
          'Yedeer专注于为全球语言人才提供全职和兼职翻译工作，为国内外语言工作者提供在线增值服务。平台可以为您提供大量的多语种口译和笔译项目。'
        ],
        introductionthree: [
          'You can register via phone number or email address, and join a project after completing personal resume and taking a language test. When finishing your project, you can verify your earnings and submit a settlement request online, which is easy and clear.',
          '您可以通过电话号码或电子邮件地址注册，并在完成个人简历和语言测试后加入项目。完成项目后，您可以核实计费并在线提交结算请求，简单明了。'
        ],
        introductionfour: [
          'If you are looking for a translation job, join us now. Here are various translation opportunities and convenient ways of settlement. We are now recruiting language lovers, native-speaking translators, interpreters and translators from countries around the world. Let us realize your translation dream!',
          '如果您渴望翻译工作，请立即加入我们。这里有各种各样的翻译项目和方便的结算方式。我们正在招聘来自世界各地的语言爱好者、母语译员、口译和笔译人员。您的翻译梦想将从此启航！'
        ]
      }
    }

    return languagedata[componentName]
  }
}
